/**
 * Takes a username and tries to return the users name from it
 * @param {string} input the full username
 * @returns {string} the formatted string. NOTE: This will only clean up Z
 * usernames at the moment because we don't know what the format of telnet
 * usernames will be.
 */
export default function formatUserName(input: string): string {
  const zDomain = "@z.co.nz";
  if (input && input.indexOf(zDomain) > 0) {
    // Should change "firstname.lastname@z.co.nz" to "firstname lastname"
    return input.replace(zDomain, "").replace(".", " ");
  }

  return input;
}
